import { selectItemEvent } from './utils/selectItem';

export function selectRelatedProduct() {
  const relatedProducts = document.querySelectorAll<HTMLAnchorElement>(
    '[data-related-product]',
  );

  relatedProducts.forEach((product) => {
    product.addEventListener('click', () => {
      const id = product.dataset.ga4ProductId!; // Required parameter
      const itemName = product.dataset.ga4ProductName!; // Required parameter
      const price = Number(product.dataset.ga4ProductPrice);
      const itemlist = product.dataset.ga4ProductList!;

      const item: Item = {
        item_id: id,
        item_name: itemName,
        price: price,
        item_list_name: itemlist,
      };

      selectItemEvent(item);
    });
  });
}
